<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.bulks.retrieveLoader">
      <v-skeleton-loader transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'RetentionList'}">Facturas de compra</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'RetentionBulkListCreate'}">Lotes</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            <code class="body-2 text--secondary">{{instance.id}}</code>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <template v-if="(instance.only_draft && ['pending', 'failed', 'finalized'].includes(instance.status)) || (!instance.only_draft && ['pending', 'failed'].includes(instance.status))">
                <v-btn class="d-block" @click="destroy" outlined color="red" retain-focus-on-click :ripple="false">Eliminar lote</v-btn>
              </template>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-row class="px-4">
            <v-col cols="2">
              <span class="d-block mb-1">Facturas</span>
              <span class="body-1 font-weight-medium mr-1">{{count}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Creado el</span>
              <span class="body-1 font-weight-medium mr-1">{{instance.created | date}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Estado</span>
              <v-chip v-if="instance.status === 'pending'" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
              <v-chip v-if="instance.status === 'processing'" class="caption" color="defaultGrey" text-color="secondary" small>Procesando</v-chip>
              <v-chip v-if="instance.status === 'finalized'" color="lightBlue" text-color="primary" small>Finalizado<v-icon x-small>mdi-check</v-icon></v-chip>
              <v-chip v-if="instance.status === 'failed'" class="caption" color="defaultGrey" text-color="secondary" small>Fallido<v-icon x-small>mdi-close</v-icon></v-chip>
            </v-col>
          </v-row>

          <v-divider />

          <v-list>
            <!-- process progress -->
            <!-- <template v-if="instance.status === 'processing'">
              <v-list-item class="py-1" key="process-progress-item">
                <v-list-item-icon><v-icon color="primary">mdi-clock-time-three-outline</v-icon></v-list-item-icon>
                <v-list-item-title>
                  <span class="d-block body-2 text--secondary font-weight-medium">Finaliza <template v-if="!timeLeft">pronto...</template><template v-else>en {{timeLeft}} minutos aprox.</template></span>
                  <v-progress-linear class="mt-2" color="indigo" height="6" indeterminate rounded stream />
                </v-list-item-title>
              </v-list-item>
              <v-divider key="process-progress-divider" />
            </template> -->
            <!-- end process progress -->

            <!-- status transitions -->
            <template v-for="t in instance.transitions.filter(t => ['pending', 'processing'].includes(t.status))">
              <v-list-item class="py-1" :key="t.status">
                <template v-if="t.status === 'processing'">
                  <v-list-item-icon><v-icon color="primary">mdi-check-all</v-icon></v-list-item-icon>
                  <v-list-item-title>
                    <span class="d-block body-2 text--secondary font-weight-medium">Aprobado por {{ t.user }}</span>
                    <span class="d-block">{{t.created | dateTime}}</span>
                  </v-list-item-title>
                </template>
                <template v-else-if="t.status === 'pending'">
                  <v-list-item-icon><v-icon color="primary">mdi-progress-upload</v-icon></v-list-item-icon>
                  <v-list-item-title>
                    <span class="d-block body-2 text--secondary font-weight-medium">Iniciado por {{ t.user }}</span>
                    <span class="d-block">{{t.created | dateTime}}</span>
                  </v-list-item-title>
                </template>
              </v-list-item>
              <v-divider :key="`${t.status}-divider`" />
            </template>
            <!-- end status transitions -->
          </v-list>

          <!-- records -->
          <retention-list :has-link="false" :show-status="instance.status !== 'pending'" :show-create="true" :show-sort="false" :show-select-row="instance.status === 'pending'" :show-pagination="false" />
          <!-- end records -->

          <v-divider />
          <v-row class="mx-0" align="center">
            <v-col cols="6">
              <v-btn :to="{ name: 'RetentionList', query: { bulk: instance.id } }" outlined color="secondary">Ver todas las facturas</v-btn>
            </v-col>
            <v-col class="text-right" cols="6">
              <v-btn @click="finalize" v-if="instance.status === 'pending'" outlined color="secondary">Aprobar todo</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'

import RetentionList from '@/components/purchase/RetentionList'

import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  components: {
    RetentionList
  },
  data: () => ({
    eachTime: 3,
    timeLeft: 0
  }),
  created () {
    this.retrieve()
  },
  // beforeDestroy () {
  //   if (this.instance.status === 'processing') {
  //     clearInterval(this.interval)
  //   }
  // },
  computed: mapState({
    count: state => state.purchases.retentionsCount,
    instance: state => state.bulks.retentionsDetail,
    retentionsList: state => state.purchases.retentionsList
  }),
  methods: {
    setTimeLeft () {
      const processingTransition = this.instance.transitions.filter(t => t.status === 'processing')

      const start = moment(processingTransition.created)
      const totalTime = 400 * this.eachTime

      const end = start.add(totalTime, 'seconds')
      const now = moment()

      const diff = end.diff(now, 'seconds')

      if (diff <= 0) {
        this.timeLeft = 0
        clearInterval(this.interval)
      } else {
        this.timeLeft = Math.ceil(diff / 60)
      }
    },
    retrieve () {
      this.$store.dispatch('bulks/RETRIEVE', {
        resource: 'bulks/retentions',
        id: this.$route.params.id
      })
      .then(() => {
        this.$store.dispatch('purchases/LIST', {
          resource: 'retentions',
          query: {
            bulk: this.$route.params.id,
            page_size: 10
          }
        })
      })
      // .then(() => {
      //   if (this.instance.status === 'processing') {
      //     this.setTimeLeft()
      //     this.interval = setInterval(this.setTimeLeft, 1000)
      //   }
      // })
    },
    destroy () {
      this.$dialog.warning({
        title: 'Eliminar lote',
        text: `
          <span class="d-block my-2">¿Estás seguro de continuar?</span>
          <span class="d-block my-2 font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('bulks/DESTROY', {
                resource: 'bulks/retentions',
                id: this.$route.params.id
              })
              .then(() => {
                this.$router.push({ name: 'RetentionBulkListCreate' })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    finalize () {
      const process = () => {
        this.$store.dispatch('bulks/CREATE', {
          resource: 'bulks/retentions',
          detail: 'finalize',
          id: this.$route.params.id,
          payload: {
            retentions: 'all'
          }
        })
        .then(() => {
          if (this.instance.only_draft) {
            this.$router.push({ name: 'RetentionList', query: { bulk: this.instance.id } })
          } else {
            this.$router.push({ name: 'RetentionBulkListCreate', query: { status: 'processing' } })
          }
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
      }

      this.$dialog.warning({
        title: 'Procesar lote',
        text: `
          <span class="d-block mb-4">Al confirmar se comenzarán a crear las facturas de compra importadas desde el archivo.</span>
          <span class="d-block font-weight-medium my-4">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'primary',
            handle: process,
            text: 'Procesar'
          }
        ]
      })
    }
  }
}
</script>